//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  input
} from '@angular/core';

//local imports

import {
  IBreadcrumbItemModel
} from '@app/shared/components/breadcrumb/models';

@Component({
    selector: 'breadcrumb-item',
    templateUrl: './breadcrumb-item.component.html',
    styleUrl: './breadcrumb-item.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class BreadcrumbItemComponent {
    
  public data = input<IBreadcrumbItemModel>(null);  
  
}
